import React from 'react';
import GlobalErrorsBox from '../../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import Label from '../../FormElements/Label';
import TextInput from '../../FormElements/TextInput';
import Select2DropdownList from '../../FormElements/Select2DropdownList';
import Switch from '../../FormElements/Switch';
import FormSection from '../../FormElements/FormSection';
import FormSubmit from '../../FormElements/FormSubmit';
import LoaderOverlay from '../../LoaderOverlay/LoaderOverlay';

export default class EditUserDemographicDataForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			first_name: '',
			last_name: '',
			email_address: '',
			branch: '',
			roles: [],
			is_reportable: null,
			globalErrors: [],
			fieldErrors: {}
		};

		this.onChange = this.onChange.bind(this);
		this.onSetFieldError = this.onSetFieldError.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidMount() {
		console.log('About to load data...');
		if (this.props.iam_get_user_profile_endpoint) {
			this.loadData();
		}
	}

	componentDidUpdate(prevProps) {
		// console.log('prevProps', prevProps);
		if (
			prevProps.iam_get_user_profile_endpoint !==
			this.props.iam_get_user_profile_endpoint
		) {
			// console.log('About to reload data...');
			this.loadData();
		}
	}

	render() {
		// console.log(
		// 	'Edit User Profile Form - Props',
		// 	this.props,
		// 	'Edit User Profile Form - State',
		// 	this.state
		// );

		return (
			<div className="FormElements">
				<form onSubmit={this.onSubmit}>
					<FormSection>
						<GlobalErrorsBox globalErrors={this.state.globalErrors} />
						<div className="my-3">
							<Label>{I18n.t('admin.user_profile.first_name')}</Label>
							<TextInput
								style={this.styleTextInputOnError('first_name')}
								placeholder=""
								name="first_name"
								value={this.state.first_name}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
						<div className="my-3">
							<Label>{I18n.t('admin.user_profile.first_name')}</Label>
							<TextInput
								style={this.styleTextInputOnError('last_name')}
								placeholder=""
								name="last_name"
								value={this.state.last_name}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
						<div className="my-3">
							<Label>{I18n.t('admin.user_profile.email_address')}</Label>
							<TextInput
								style={this.styleTextInputOnError('email_address')}
								placeholder=""
								name="email_address"
								value={this.state.email_address}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
						{/*<div className="mb-3">
							<Select2DropdownList
								style={this.styleTextInputOnError('branch')}
								name="branch"
								value={this.state.branch}
								// dataPlaceholder={I18n.t('admin.user_profile.branch')}
								data={[

								]}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
              </div>*/}
						<div className="my-3">
							<Label>{I18n.t('admin.user_profile.branch')}</Label>
							<TextInput
								style={this.styleTextInputOnError('')}
								placeholder=""
								name="branch"
								value={this.state.branch}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
						<div className="my-3">
							<Label>{I18n.t('admin.user_profile.roles')}</Label>
							<TextInput
								style={this.styleTextInputOnError('')}
								placeholder=""
								name="roles"
								value={this.state.roles}
								onChange={this.onChange}
								fieldErrors={this.state.fieldErrors}
							/>
						</div>
						<div className="my-3">
							<Label>{I18n.t('admin.user_profile.is_reportable')}</Label>
							<Switch
								isOn={this.state.is_reportable}
								handleToggle={() => {
									this.props.onChange({
										target: {
											name: 'is_reportable',
											value: !true
										}
									});
								}}
							/>
						</div>
					</FormSection>
					<FormSubmit
						text={I18n.t(
							'admin.user_profile.update_user_profile_submit_button'
						)}
					/>
				</form>
				{this.state.loading ? <LoaderOverlay /> : null}
			</div>
		);
	}

	styleTextInputOnError(fieldName) {
		if (this.state.fieldErrors) {
			if (fieldName in this.state.fieldErrors) {
				return { border: '1px solid #ff3d60', borderRadius: '5px' };
			}
		}
	}

	onChange(e) {
		let { ...state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSetFieldError(errorsArray, error) {
		if (errorsArray.includes(error)) {
			return 'Error';
		}
	}

	onSubmit(e) {
		// console.log(
		// 	'Editing User Profile..',
		// 	this.props.update_user_profile_endpoint
		// );
		e.preventDefault();
		e.stopPropagation();

		this.setState({
			loading: true
		});

		$.ajax({
			type: 'POST',
			url: this.props.iam_update_user_profile_endpoint,
			data: {
				first_name: this.state.first_name,
				last_name: this.state.last_name,
				email_address: this.state.email_address,
				branch: this.state.branch,
				roles: this.state.roles,
				is_reportable: this.state.is_reportable
			},
			dataType: 'json'
		}).done((data) => {
			// console.log('Done!', data);
			if (data.success === true) {
				// console.log('User Profile updated!', data);
				this.setState({
					loading: false
				});
				this.props.onHidePopup();
				this.props.onShowSuccessCardPopup();
			} else if (data.status == 'session_expired') {
				// console.log('Session expired!');
				this.props.onHidePopup();
				this.props.onShowTimeoutCardPopup(
					setTimeout(() => {
						window.location.href = `/admin/${this.props.public_id}/signin`;
					}, 5000)
				);
			} else {
				// console.log('User Profile update failed!');
				this.setState({
					loading: false,
					globalErrors: data.errors.global,
					fieldErrors: data.errors.fields
				});
			}
		});
	}

	loadData() {
		this.setState({ loading: true });
		$.ajax({
			type: 'GET',
			url: this.props.iam_get_user_profile_endpoint
		}).done((payload) => {
			const result = payload;
			// console.log('User Profile data loaded!', result);
			this.setState({
				loading: false,
				first_name: 'Abe',
				last_name: 'Foreman',
				email_address: 'abe.frohman@example1.com',
				branch: 'Battlefield Blvd.',
				roles: [],
				is_reportable: true
			});
		});
	}
}
